import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  form: {
    width: '100%',
  },
  buttonWrapper: {
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  prevButton: {
    position: 'fixed',
    top: 10,
    left: 10,
  },
});

export default useStyles;
